import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TrendingTopicCard = ({ topic }) => {
  const getSentimentColor = (sentiment) => {
    if (sentiment === 'positive') return 'text-success';
    if (sentiment === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getSentimentIcon = (sentiment) => {
    if (sentiment === 'positive') return 'TrendingUp';
    if (sentiment === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const getRelevanceColor = (score) => {
    if (score >= 90) return 'var(--color-success)';
    if (score >= 80) return 'var(--color-primary)';
    if (score >= 70) return 'var(--color-accent)';
    return 'var(--color-muted-foreground)';
  };

  return (
    <div className="bg-background rounded-lg p-3 border border-border hover:border-accent/30 transition-all">
      {/* Header */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <h4 className="text-sm font-bold text-accent mb-1">{topic?.hashtag}</h4>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-muted-foreground">
              {topic?.mentions?.toLocaleString()} mentions
            </span>
            <span className="text-xs text-muted-foreground">•</span>
            <div className={`flex items-center gap-1 ${getSentimentColor(topic?.sentiment)}`}>
              <Icon name={getSentimentIcon(topic?.sentiment)} size={12} />
              <span className="text-xs font-medium">{topic?.growth}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Relevance Score */}
      <div className="mb-3">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-muted-foreground">Relevance Score</span>
          <span className="text-xs font-semibold" style={{ color: getRelevanceColor(topic?.relevanceScore) }}>
            {topic?.relevanceScore}%
          </span>
        </div>
        <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${topic?.relevanceScore}%`,
              backgroundColor: getRelevanceColor(topic?.relevanceScore)
            }}
          ></div>
        </div>
      </div>

      {/* Top Influencers */}
      {topic?.topInfluencers && topic?.topInfluencers?.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-muted-foreground mb-1">Top Influencers:</p>
          <div className="flex flex-wrap gap-1">
            {topic?.topInfluencers?.map((influencer, index) => (
              <span
                key={index}
                className="text-xs px-2 py-0.5 rounded-full bg-muted text-foreground"
              >
                {influencer}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Suggested Action */}
      {topic?.suggestedAction && (
        <div className="mb-3 p-2 rounded-lg bg-accent/10 border border-accent/20">
          <div className="flex items-start gap-2">
            <Icon name="Lightbulb" size={14} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs text-foreground">{topic?.suggestedAction}</p>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex gap-2">
        <Button variant="outline" size="xs" iconName="Plus" className="flex-1">
          Track
        </Button>
        <Button variant="outline" size="xs" iconName="PenTool" className="flex-1">
          Create Post
        </Button>
      </div>
    </div>
  );
};

export default TrendingTopicCard;